<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">

            <b-tab :title="'الأنشطة'" @click="fire2()" active>
              <data-table2 :editItem="editItemNew" />
            </b-tab>
      
            <b-tab @click="fire()" :title="'أضف '">
              <my-form2 :newItem="newItemNew" :homeWork="homeWork" :getActivities="getActivities"
                :getSubjectCodes="getSubjectCodes" :getActivityCodes="getActivityCodes" :types="types"
                :activitiesCodes="activitiesCodes" :subjects="subjects" />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>
<script>
import DataTableVue2 from './components/DataTable2.vue'
import FormVue2 from './components/Form2.vue'
import SemesterController from "@/Controllers/SemesterController";
export default {
  name: 'ActivitiesIndex',
  components: {
    'data-table2': DataTableVue2,
    'my-form2': FormVue2
  },
  data() {
    return {
      newItem: {},
      tab: 0,
      newItemNew: {
        subjectCode: "",
        semesterCode: "",
        type: "",
        code: "",
        homework: "",
        homework_name: "",
        forum_name: "",
        description: "",
        education_level: "",
        from: "",
        to: "",
        homework_type: "",
        rate_type: "",
        subject: "",
        discussion: "",
        short_exam_name: "",
        period: "",
        period_type: "",
        attemps: "",
        allow: true,
        questions: [],
        edit : 0

      },
      controller: new SemesterController(),

      types: [],
      activitiesCodes: [],
      subjects: [],
      activities: [],

    }
  },
  created() {
    // console.log('df');
    // console.log(this.homeWork);
  },
  methods: {
    fire2() {
      this.newItemNew = {
        subjectCode: "",
        semesterCode: "",
        type: "",
        code: "",
        homework: "",
        homework_name: "",
        forum_name: "",
        description: "",
        education_level: "",
        from: "",
        to: "",
        homework_type: "",
        rate_type: "",
        subject: "",
        discussion: "",
        short_exam_name: "",
        period: "",
        period_type: "",
        attemps: "",
        allow: true,
        questions: [],
        edit : 0
      }
    },
    editItemNew(data) {
      let item = data.item;
      let newItem = {
        subjectCode: item.subject_code,
        semesterCode: item.semester_code,
        type: item.activity_type,
        from: item.from_date ,
        to: item.to_date ,
        education_level: item.eductional_level,
        code: item.code,
        id: item.id

      }

      if (item.activity_type === 'واجب' || item.activity_type == "مشروع") {
        newItem.description = item.assignment_and_projects_data.description;
        newItem.max_files_allowed_count = item.assignment_and_projects_data.max_files_allowed_count
        newItem.file_size = item.assignment_and_projects_data.file_size;
        newItem.homework_type = item.assignment_and_projects_data.type;
        newItem.homework_name = item.name;
        newItem.disallow_delayed_homeworks = item.assignment_and_projects_data.disallow_delayed_homeworks == 1 ? true : false
        newItem.allow_resubmit = item.assignment_and_projects_data.allow_resubmit == 1 ? true : false,
        newItem.assignment_id = item.assignment_and_projects_data.assignment_id;
      }else if(item.activity_type == 'منتدي'){
        newItem.forum_name = item.name;
        newItem.file_size = item.forums_data.file_size;
        newItem.max_files_allowed_count = item.forums_data.max_files_allowed_count;
        newItem.rate_type = item.forums_data.rate_type;
        newItem.subject = item.forums_data.subject;
        newItem.discussion = item.forums_data.discussion
        newItem.forum_id = item.forums_data.forum_id;
      }else{
        let questions = [];
        for(let i = 0;i<item.short_exams_data.questions.length;i++){
          let question = item.short_exams_data.questions[i];
          let questionObject = {
            type : question.type,
            education_results : question.education_results,
            difficulty : question.difficulty,
            cognitive_ability : question.cognitive_ability,
            question : question.question,
            mark : question.mark,
            owner: question.owner || '',
          };

          
        if(question.type == 'صح و خطأ'){
            questionObject.type_2_answer = question.answer;
          }else if(question.type == 'متعدد الأختيارات و اجابات'){
            let answers = []
            let correctIndexes = []
            for (let x = 0; x < question.answers.length; x++) {
              answers.push({ answer: question.answers[x].answer , answer_id: question.answers[x].answer_id});
              if(question.answers[x].value === 1) {
                correctIndexes.push(x);
              }
            }
            questionObject.type_3_answers = answers;
            questionObject.correctAnswersIndexes = correctIndexes;
          }else if(question.type == 'متعدد الأختيارات و اجابة'){
            let answers = []
            for (let x = 0; x < question.answers.length; x++) {
              answers.push({ answer: question.answers[x].answer , answer_id: question.answers[x].answer_id});
            }
            questionObject.type_1_answers = answers;
            // Find correct answer index
            questionObject.correctAnswerIndex = question.answers.findIndex(ans => ans.value === 1);
          }else if(question.type == 'ترتيب الأجابات'){
            let answers = []
            for (let x = 0; x < question.answers.length; x++) {
              answers.push({ 
                answer: question.answers[x].answer,
                order: question.answers[x].answer_order || (x + 1),
                answer_id: question.answers[x].answer_id
              });
            }
            questionObject.type_4_answers = answers;
          }else{
            // For essay, fill in blank, etc.
            questionObject.correct_answer_text = question.answer || '';
          }
          questionObject.question_id = question.question_id;
          questions.push(questionObject);
        }

        newItem.short_exam_name = item.name;
        newItem.attemps = item.short_exams_data.attemps;
        newItem.rate_type = item.short_exams_data.rate_type;
        newItem.allow = item.short_exams_data.allowed_periods == 1 ? true : false;
        newItem.period = item.short_exams_data.period;
        newItem.period_type = item.short_exams_data.period_type;
        newItem.questions = questions;
        newItem.short_exam_id = item.short_exams_data.short_exam_id;
      }
      this.newItemNew = newItem;
      this.getSubjectCodes();
      this.getActivities();
      this.getActivityCodes();
      this.newItemNew.edit =1;
      this.tab = 2
    },
    getSubjectCodes(e) {
      this.controller.getSubjects(this.newItemNew.semesterCode).then((response) => {
        this.subjects = response;
                //toRemove 
            this.subjects.push("MPU2312");
      });
    },
    async getActivities() {
      const res = await this.controller.getActivities(this.newItemNew.semesterCode, this.newItemNew.subjectCode);
      this.activities = res.activityItems;
      this.types = Array.from(new Set(res.activityItems.map((item) => item.type.toLowerCase())))
        .map((activity) => {
          return this.translateActivity(activity)
        });
    },
    getActivityCodes() {

      this.activitiesCodes = this.activities.filter((item) => {
        return this.translateActivity(item.type.toLowerCase()) == this.newItemNew.type
      }).map((item) => item.code);

    },

    translateActivity(activity) {
      if (activity == 'assignment') {
        return 'واجب'
      } else if (activity == 'project') {
        return 'مشروع'
      } else if (activity == 'forum') {
        return 'منتدي'
      } else if (activity == 'quiz') {
        return 'امتحان قصير'
      }
      return activity;
    },
 
  },
}
</script>
